import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { mergeMap, switchMap } from 'rxjs/operators';
import { CommSchemeSetupApiService } from '@cms/apis';
import { CommSchemeSetupAction } from '../actions';
import { CommSchemeSetupSelector } from '../selectors';

@Injectable()
export class CommSchemeSetupEffects {
  getItemDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommSchemeSetupAction.loadItemDetail),
      mergeMap(({ id }) => this.apiService.get(id)),
      switchMap(item => of(CommSchemeSetupAction.setItemDetail({ item })))
    )
  );

  reloadItemDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommSchemeSetupAction.reloadItemDetail),
      concatLatestFrom(() => this.store.select(CommSchemeSetupSelector.selectCommSchemeSetupDetail)),
      mergeMap(([_, item]) => {
        if (item) {
          return this.apiService.get(item.id);
        }
        return of(null);
      }),
      switchMap(item => of(CommSchemeSetupAction.setItemDetail({ item })))
    )
  );


  constructor(private actions$: Actions, private store: Store, private apiService: CommSchemeSetupApiService) { }
}
